export default{
    title: '罗达莱克斯阀门档案管理系统',
}